<template>
    <div class="addPage">
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="100px" size="mini">
            <div style="width: 100%;margin-bottom: 10px" class="flex" align="left">
                <!--<el-form-item class="form-title" prop="dt_begin_time" label="开始时间" >
                    <el-date-picker
                            :disabled="edit"
                            v-model="formData.dt_begin_time"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item class="form-title" prop="dt_disable_time" label="失效时间" >
                    <el-date-picker
                            :disabled="edit"
                            v-model="formData.dt_disable_time"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>-->
                <el-form-item >
                    <div class="pz" style="text-align: left;margin-left: -100px;">
                        <el-button class="bcBtn" @click="saveBtn('formRef')" v-bind:disabled="isSaved" :class="baseerp+'btn'" size="mini">
                            {{$t('button_save')}}
                        </el-button>
                        <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
                    </div>
                </el-form-item>
                <el-form-item class="form-title num" prop="num" label="No:" >
                    <span  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                </el-form-item>
            </div>
            <div class="proItem" style="width: 100%;border-bottom: none">
                <div class="pz">
                    <template>
                        <el-table
                                ref="table"
                                size="mini"
                                :height="tableHeight"
                                border
                                :key="tableId"
                                :row-class-name="tableRowClassName"
                                :data="tableDataNew"
                                style="width: 100%">
                            <template slot="empty">
                                <p>{{dataTextNew}}</p>
                            </template>
                            <el-table-column width="35px" align="center">
                                <template  slot-scope="scope">
                                    <div class="iconminus">
                                        <span class="minus" @click="delTraderResource(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column  show-overflow-tooltip
                                              :label="$t('form_product_name')"
                                              align="center"
                                              prop="vc_name" >
                            </el-table-column>
                            <el-table-column
                                    width="80"
                                    align="center"
                                    label="规格"
                                    prop="vc_bzstyle"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="产地"
                                    prop="vc_cd" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="生产厂商"
                                    prop="vc_gykh" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="vc_gsname" :label="$t('form_company')" align="center" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="vc_ckname" :label="$t('form_warehouse')" align="center" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="kysl" :label="$t('form_available_quantity')" align="center" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="上次价格"
                                    prop="f_last_price">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="价格"
                                    prop="f_price">
                                <template slot-scope="scope">
                                    <el-form-item class="tableForm-item" :prop="'tableDataNew.'+scope.$index+'.f_price'" :rules="formRules.f_price">
                                        <el-input  class="changeinput" v-model="scope.row.f_price" @change="priceCtrl(scope.row,scope.$index)" :disabled="scope.row.i_old_id!==0&&scope.row.i_state==1"  size="mini"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="价格浮动"
                                    prop="f_fd_price">
                            </el-table-column>
                            <el-table-column prop="i_bzid" label="币种" align="center" width="80px">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.i_bzid" size="mini" filterable allow-create style="width:100%" >
                                        <el-option
                                                v-for="item in currencyList"
                                                :key="item.i_bzid"
                                                :label="item.vc_bzname"
                                                :value="item.i_bzid">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="挂牌总量"
                                    prop="f_total_num">
                                <template slot-scope="scope">
                                    <el-form-item class="tableForm-item" :prop="'tableDataNew.'+scope.$index+'.f_total_num'" :rules="formRules.f_total_num">
                                        <el-input class="changeinput" size="mini" v-model="scope.row.f_total_num" @change="totalNum(scope.row,scope.$index)" ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    width="90"
                                    align="center"
                                    label="最小购买量"
                                    prop="f_min_num">
                                <template slot-scope="scope" >
                                    <el-form-item class="tableForm-item" :prop="'tableDataNew.'+scope.$index+'.f_min_num'" :rules="formRules.f_min_num">
                                        <el-input class="changeinput" size="mini"
                                         v-model="scope.row.f_min_num" @change="minNum(scope.row,scope.$index)" ></el-input><!--:disabled="scope.row.i_old_id!==0"-->
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    width="70px"
                                    align="center"
                                    label="计量单位"
                                    prop="vc_unit"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="操作"
                                    :formatter="StatusNew"
                                    prop="i_state" show-overflow-tooltip>
                            </el-table-column>

                        </el-table>
                    </template>
                </div>
                <div class="pz bg">
                    <el-form-item >
                        <div class="pz" style="text-align: left;margin:5px 0 5px -100px;">
                            <el-button class="bcBtn" @click="getPzMessage(0)"  size="mini" type="primary" plain>
                                全部
                            </el-button>
                            <el-button class="bcBtn" @click="getPzMessage(1)"  size="mini" type="success" plain>
                                已上架
                            </el-button>
                            <!--<el-button class="bcBtn" @click="getPzMessage(2)" :class="baseerp+'btn'" size="small">
                                未上架
                            </el-button>-->
                            <el-button class="bcBtn" @click="getPzMessage(2)"  size="mini" type="warning" plain>
                                审批中
                            </el-button>
                        </div>
                    </el-form-item>
                    <template>
                        <el-table
                                :header-cell-style="{background:'#f6f6f6'}"
                                ref="table"
                                size="mini"
                                :height="tableHeight"
                                border
                                :key="tableId"
                                :data="tableData"
                                style="width: 100%;">
                            <template slot="empty">
                                <p>{{dataText}}</p>
                            </template>
                                <el-table-column  show-overflow-tooltip
                                        :label="$t('form_product_name')"
                                        align="center"
                                        prop="vc_name" >
                                </el-table-column>
                                <el-table-column
                                        width="80"
                                        align="center"
                                        label="规格"
                                        prop="vc_bzstyle"
                                        show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column
                                        align="center"
                                        label="产地"
                                        prop="vc_cd" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column
                                        align="center"
                                        label="生产厂商"
                                        prop="vc_gykh" show-overflow-tooltip>
                                </el-table-column>
                            <el-table-column prop="vc_gsname" :label="$t('form_company')" align="center" show-overflow-tooltip >
                            </el-table-column>
                            <el-table-column prop="vc_ckname" :label="$t('form_warehouse')" align="center" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="kysl" :label="$t('form_available_quantity')" align="center" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="上次价格"
                                    prop="f_last_price">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    label="价格"
                                    prop="f_price">
                            </el-table-column>
                            <el-table-column prop="i_bzid" label="币种" align="center" width="80px">
                            </el-table-column>
                                <el-table-column
                                        align="center"
                                        label="挂牌总量"
                                        prop="f_total_num">
                                </el-table-column>
                                <el-table-column
                                        width="90"
                                        align="center"
                                        label="最小购买量"
                                        prop="f_min_num">
                                </el-table-column>
                            <el-table-column
                                    width="70px"
                                    align="center"
                                    label="计量单位"
                                    prop="vc_unit"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    width="50"
                                    align="center"
                                    label="状态"
                                    :formatter="Status"
                                    prop="i_state" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label="操作" width="80" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" v-if="scope.row.i_state==2"  @click="pushFun(scope.row,scope.$index,1)" style="color: red" >下架</el-button>
                                    <el-button type="text" size="small" v-if="scope.row.i_state!==0"  @click="pushFun(scope.row,scope.$index,2)" style="color: #0491ff">调价</el-button>
                                    <el-button type="text" size="small" v-if="scope.row.i_state==0"  @click="pushFun(scope.row,scope.$index,3)" style="color: #84cf63">新增</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                    <el-pagination  style="margin-top: 10px;text-align: right"
                                    background
                                    @current-change="pageCurrentChange"
                                    layout="total,prev, pager, next"
                                    :current-page.sync="currentPage"
                                    :page-size="pageCount"
                                    :total="total">
                    </el-pagination>
                </div>
            </div>
        </el-form>
    </div>
</template>
<script>
    import * as API from  "./../api";
    import {baseerp} from "@/utils/baseUrl";
    import {filerequest_url} from './../api';
    import {mapActions} from "vuex";
    export default {
        name: 'AddDialog',
        props:{
          add:{
              type: Object,
              required:true,
          }
        },
        data(){
            //只能输入数字
            var validateNum= (rule, value, callback) =>{
                if (!Number.isFinite(value*1)) {
                    callback(new Error('请输入数字值'));
                }else {
                    // callback((value*1).toFixed(2));
                }
                // value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '');
            };
            return{
                pageSize:1,
                pageCount:20,
                total:0,
                currentPage:1,
                formRef:{},
                trader:[],
                companyName:[],
                currencyList:[
                    {i_bzid:1,vc_bzname:"元"},
                    {i_bzid:2,vc_bzname:"美元"},
                    {i_bzid:3,vc_bzname:"欧元"},
                    {i_bzid:10268,vc_bzname:"越南盾"}
                ],
                personName:[],
                warehouseList:[],
                formData:{
                    sqName:"",
                    num:"",
                    tableDataNew: [],
                    tableData: [],
                },
                popData:{},
                formRules:{
                   /* company_id:[{required:true,message:"请选择公司",trigger:"change"}],
                    i_bzid:[{required:true,message:"请选择币种",trigger:"change"}],
                    warehouse_id:[{required:true,message:"请选择仓库",trigger:"change"}],*/
                    /*unit_price:[{required:true,message:"请输入会员单价",trigger:"change"}],
                    show_unit_price:[{required:true,message:"请输入游客单价",trigger:"change"}],*/
                    f_price:[{required:true,message:"请输入价格",trigger:"change"},
                        { validator: validateNum, trigger: 'blur' }],
                    f_total_num:[{required:true,message:"请输入挂牌总量",trigger:"change"},
                        { validator: validateNum, trigger: 'blur' }],
                    f_min_num:[{required:true,message:"请输入最小购买量",trigger:"change"},
                        { validator: validateNum, trigger: 'blur' }],
                },
                companyList:[],
                i_bzid:0,
                warehouse_id:0,
                tableDataNew: [],
                pushData: [],
                tableData: [],
                search: '',
                isSaved:false,
                baseerp:'',
                price:0,
                edit:false,
                visible:false,
                isbtn:false,
                tableHeight:0,
                dataText:this.$t('tips_data_loading_in_progress'),
                dataTextNew:this.$t('tips_data_loading_in_progress'),
                tableId:"",
                pzName:"",
                newAdd:{},
            }
        },
        mounted() {
            this.newAdd=JSON.parse(JSON.stringify(this.add))
            this.baseerp=baseerp;
            // this.i_pid=this.newAdd.i_id;
            // console.log(this.newAdd.i_id,"add")
            this.formData.num=this.newAdd.i_id
            // if (this.newAdd.i_id==0){this.edit=false}else{this.edit=true}
            // this.getTraderResources();
            this.getPzMessage();
            if (this.newAdd.i_id!==0){
                this.getTraderResources();
            }else {
                this.dataTextNew=this.$t('tips_no_data_available_at_the_moment')
            }
            this.$nextTick(function () {
                window.addEventListener('resize',this.heightAuto);
                this.heightAuto();
            });
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            heightAuto(){
                this.tableHeight = (window.innerHeight - this.$refs.table.$el.clientTop - 260)/2;
            },
             //获取已保存列表
            async getTraderResources(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                    page_size:this.pageSize,
                    page_count:15,
                    i_pid:this.newAdd.i_id,
                };
                let res=await API.getTraderResources(params);
                if(res.code==1){
                    if (res.data.length==0){
                        this.tableDataNew=res.data;
                        this.formData.tableDataNew=res.data;
                        this.dataTextNew=this.$t('tips_no_data_available_at_the_moment')
                    }else {
                        this.tableDataNew=res.data;
                        this.formData.tableDataNew=res.data;

                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }

            },
            async getPzMessage(i_state){
                let params={
                    "search":this.pzName,
                    "page_size":this.pageSize,
                    "page_count":this.pageCount,
                    i_state:i_state,
                }
                let res=await API.getPzMessage(params);
                if(res.code==1){
                    if (res.data.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.tableData=res.data;
                    this.formData.tableData=res.data;
                    this.total=res.total;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //i_state:1已上架2.审核中3.保存未提交
            pushFun(row,index,i_state){
                this.pushData=[];
                this.pushData.push(JSON.parse(JSON.stringify(row)));
                if(this.newAdd.i_id!==0){
                    this.pushData[0].i_pid=this.newAdd.i_id;
                }
                this.pushData[0].i_old_id=row.i_gpid;
                this.pushData[0].i_pz_pid=row.i_pid;
                this.pushData[0].i_pzid=row.i_id;
                this.pushData[0].i_id=0;
                this.pushData[0].i_state=i_state;
                let arr=[];
                if (this.tableDataNew.length>0){
                    arr=[...this.pushData,...this.tableDataNew];
                }else if (this.tableDataNew.length==0){
                    arr=this.pushData;
                };
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.i_old_id] ? '' : hash[next.i_old_id] = true && item.push(next);
                    return item
                }, []);
                this.tableDataNew=arr;
                this.formData.tableDataNew=arr;
                //console.log( this.tableDataNew," this.tableDataNew")
            },
             delTraderResource(value,index){
                // this.index=index;
                 if (value.i_id!==0){
                     this.$confirm('该操作会将该品种在已保存的列表里删除,是否继续?', '提示', {
                         confirmButtonText: '确定',
                         cancelButtonText: '取消',
                         type: 'warning'
                     }).then( async () => {
                         let param={
                             i_mid: this.mid,
                             i_id:value.i_id,
                         };
                         let res=await API.delTraderResource(param);
                         if(res.code==1){
                             this.tableDataNew.splice(index,1);
                             this.$message({
                                 type: 'success',
                                 message: '删除成功!'
                             });
                         }else if (res.code == -2) {
                             this.$router.push('/login');
                             this.$message.error(res.message);
                         }
                         else{
                             this.$message.error(res.message);
                         }
                     }).catch(() => {
                         this.$message({
                             type: 'info',
                             message: '已取消删除'
                         });
                     });
                 }else{
                     this.tableDataNew.splice(index,1);
                 }



            },
            closePop(){
                this.visible=false;
                this.isbtn=false;
            },
            minNum(row,index){
                if (this.tableDataNew[index].f_min_num>this.tableDataNew[index].f_total_num){
                    this.$message.error("最小购买量不得大于挂牌总量");
                    // this.tableDataNew[index].f_min_num=this.tableDataNew[index].f_total_num;
                    this.tableDataNew[index].f_min_num=parseFloat(this.tableDataNew[index].f_total_num).toFixed(this.$setPrecision.quantityPrecision);
                    return ;
                }else if (!isNaN(parseFloat(this.tableDataNew[index].f_min_num))){
                    this.tableDataNew[index].f_min_num=parseFloat(this.tableDataNew[index].f_min_num).toFixed(this.$setPrecision.quantityPrecision);
                    return ;
                }else if (isNaN(parseFloat(this.tableDataNew[index].f_min_num))){
                    this.tableDataNew[index].f_min_num=0;
                    return ;
                }

            },
            totalNum(row,index){
                if (this.tableDataNew[index].f_min_num??''!=='') this.minNum(row,index);
                if (this.tableDataNew[index].f_total_num>this.tableDataNew[index].kysl){
                    this.$message.error("挂牌总量不得大于可用数量");
                    this.tableDataNew[index].f_total_num=this.tableDataNew[index].kysl;
                    // this.tableDataNew[index].f_total_num=parseFloat(this.tableDataNew[index].kysl).toFixed(5);
                    return ;
                }else if (!isNaN(parseFloat(this.tableDataNew[index].f_total_num))){
                    this.tableDataNew[index].f_total_num=parseFloat(this.tableDataNew[index].f_total_num).toFixed(this.$setPrecision.quantityPrecision);
                    return ;
                }else if (isNaN(parseFloat(this.tableDataNew[index].f_total_num))){
                    this.tableDataNew[index].f_total_num=0;
                    return ;
                }
            },
            //价格浮动
            priceCtrl(val,index){
                this.tableDataNew[index].f_price=Math.round((parseFloat(this.tableDataNew[index].f_price))*100)/100;
                if (this.tableDataNew[index].f_last_price??''!==""){
                    this.tableDataNew[index].f_fd_price=((this.tableDataNew[index].f_price - this.tableDataNew[index].f_last_price) / this.tableDataNew[index].f_price).toFixed(2);
                }else {
                    this.tableDataNew[index].f_fd_price=0;
                }

                this.tableId=Math.random();
                // console.log(this.tableDataNew[index]);
                // this.price=val.f_price;
                // if (val.f_price>=this.price*1.05 || val.f_price<=this.price*0.95){
                //     // this.tableRowClassName(val);
                //     this.$message.error("请核对价格");
                // }
            },
            tableRowClassName({row,index}){
                // console.log(row.f_fd_price,"row.f_fd_price")
                // this.price=row.f_price;
                // if (this.tableDataNew[index].f_last_price??''!==""){
                    if (row.f_fd_price>=0.05 || row.f_fd_price<=-0.05){
                        return 'border_waring';
                    // }
                }
            },
            //close关闭弹窗
            cancel(){
                this.$emit('close');
            },
            //获取当前页数据
            pageCurrentChange(val){
                // console.log(val,"val")
                this.tableData=[];
                this.pageSize=val;
                this.currentPage=val;
                this.getPzMessage();
            },
            //保存按钮
            async saveBtn(ref){
                //console.log("1111")
                let  _this =this;
                _this.isSaved=true;
                if(_this.tableDataNew.length==0){
                    _this.$message.error("请选择要挂牌的品种");
                    _this.isSaved=false;
                    return ;
                }
                 /*let valid=await _this.$formRulesValidate({ref,example:this});
                if(!valid){
                    _this.isSaved=false;
                    return
                }else {*/

                    /*this.tableData.map((one) =>{
                    one.i_old_id=one.i_id;
                    one.i_id=0;
                });*/
                    let saveParams={
                        i_id:_this.newAdd.i_id,
                        i_pid:_this.newAdd.i_id,
                        i_gsid:_this.newAdd.i_gsid,
                        i_khid:_this.newAdd.i_khid,
                        i_useday:_this.newAdd.i_useday,
                        dt_begin_time:"",
                        dt_disable_time:"",
                        i_typeid:0,
                        i_type_pid:0,
                        i_lruid:sessionStorage.getItem("userid"),
                        "trader":_this.tableDataNew
                    }
                    let res=await API.saveTrader(saveParams);
                    if(res.code==1){
                        _this.$message({
                            message: '保存成功,请到待提交中查看',
                            type: 'success'
                        });
                        _this.isSaved=true;
                        _this.$emit('getTrader');
                        _this.cancel();

                    }else if (res.code == -2) {
                        _this.isSaved=false;
                        _this.$router.push('/login');
                        _this.$message.error(res.message);
                    }
                    else {
                        _this.isSaved=false;
                        _this.$message.error(res.message);
                    }
                // }
            },
            StatusNew(row, column, cellValue, index){
                if(row.i_state==0){
                    return ' '
                }else if(row.i_state==1){
                    return '下架'
                }else if(row.i_state==2){
                    return '调价'
                }else if(row.i_state==3){
                    return '新增'
                }
            },
            Status(row, column, cellValue, index){
                if(row.i_state==0){
                    return ' '
                }else if(row.i_state==1){
                    return '已上架'
                }else if(row.i_state==2){
                    return '审核中'
                }else if(row.i_state==3){
                    return ' ';//已经保存
                }
            },
        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss" >
    .addPage{
        /*.el-input-number--mini {
            width: 100%;
            line-height: 26px;
        }
        .el-input-number.is-without-controls .el-input__inner{
            padding-left: 5px;
            padding-right: 5px;
        }*/
        .el-input__inner{
            padding-left: 5px;
            padding-right: 5px;
        }
        .el-input__suffix{
            right: 0;
        }
        .el-popover{
            width: 88%;
            min-width: 880px;
        }
        .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
            margin-bottom: 0;
        }
        .flex{
            display: flex;
        }
        .el-button+.el-button {
            margin-left: 5px;
        }
        .el-table .cell {
            overflow: visible;
        }
        .el-form-item__error {
            top: 90%;
            left: -10px;
        }
        /deep/ {
            .el-checkbox__label {
                font-size: 12px;
            }

            .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
                margin-bottom: 0;
            }

            .num {
                margin-bottom: 12px;
            }

            .num .el-form-item__label {
                color: #b3d268;
                font-style: italic;
            }

            .num .el-form-item__content {
                width: 130px;
            }

        }
        .pop .addbtn{
            border: none;
            padding: 0;
        }

        /deep/ {

            .el-icon-plus {
                font-size: 20px;
                color: #efd773;
                font-weight: bolder;
            }

            .el-icon-minus {
                font-size: 20px;
                color: #4a4a4a;
                font-weight: bolder;
            }


        }
        .iconAdd{
            text-align: center;
        }
        .bg .el-table th,.bg .el-table tr{
            background-color: #f6f6f6;
        }
        /deep/{
            .el-dialog{
                margin: 0 auto 10px;
            }
            .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
                color: white;
            }
            .el-table__body .border_waring{
                border: 1px solid red;
                background-color: rgba(250,0,0,0.1);
            }

            .el-input__inner{
                padding:0 2px;
                height: 30px;
                line-height: 30px;
            }
        }

        /deep/{
            .el-table__body td{
                overflow: hidden;
            }
        }

        .changeinput{
            border: 1px solid #e0e0e0;
            border-radius: 4px;
        }
    }

    /deep/{
        /*.el-form-item__error{*/
        /*    color: #222222;*/
        /*    background-color: #fffacd;*/
        /*    padding: 2px 4px 1px 4px;*/
        /*}*/
        /*.el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus, .el-message-box__input input.invalid, .el-message-box__input input.invalid:focus {*/
        /*    border-color: #efd773;*/
        /*}*/
    }

</style>